import moment from 'moment';
import { ITelemetryContext } from './Telemetry.types';

export enum ScenarioColumns {
  CorrelationId = 'Correlation.Id',
  ScenarioName = 'Scenario.Name',
  ScenarioStatus = 'Scenario.Status',
  ScenarioStep = 'Scenario.Step'
}

export enum TelemetryScenarioStatus {
  Abandoned = 'abandoned',
  Failure = 'failure',
  Incomplete = 'incomplete',
  Init = 'init',
  Success = 'success',
  Timeout = 'timeout'
}

export enum TelemetryScenarioStep {
  Finish = 'finish',
  Pause = 'pause',
  Start = 'start'
}

export enum TelemetryScenarioName {
  EmailLoad = 'emailLoad',
  MiddleTierRequest = 'middleTierRequest',
  PageLoad = 'pageLoad'
}

export enum TelemetryScenarioErrorStatus {
  Error = 'error',
  NetworkError = 'networkError'
}

export interface ITelemetryScenarioTrackerData extends IEventData {
  id?: string;
  eventNumber?: number;
  lastUpdatedTime?: moment.Moment;
  startTime?: moment.Moment;
  finishTime?: moment.Moment;
}

export interface IMiddleTierRequestData extends IEventData {
  [ScenarioColumns.CorrelationId]?: string;
  operation?: string;
}

export interface IEventData {
  [ScenarioColumns.ScenarioName]?: TelemetryScenarioName | string;
  [ScenarioColumns.ScenarioStep]?: TelemetryScenarioStep;
  [ScenarioColumns.ScenarioStatus]?: TelemetryScenarioStatus;
  scenarioType?: string;
  outcome?: string;
  delta?: number;
  elapsed?: number;
  stepDelta?: string;
  error?: Error;
  // deprecated.
  message?: string;
  errorCode?: TelemetryScenarioErrorStatus;
}

export type MiddleTierRequestEvent = Pick<
  IMiddleTierRequestData,
  Exclude<keyof IMiddleTierRequestData, ITelemetryContext>
>;

export type TelemetryScenarioTrackerEvent = Pick<
  ITelemetryScenarioTrackerData,
  Exclude<keyof ITelemetryScenarioTrackerData, ITelemetryContext>
>;

export type IScenarioEvent<T> = {
  properties: T extends IEventData ? T : never;
};
